import 'css-chunksrc/client/common/constraintsPopup/styles.scss';export default {
  "input": "_input_1ij73_1",
  "active": "_active_1ij73_8",
  "nbr": "_nbr_1ij73_15",
  "listRoot": "_listRoot_1ij73_21",
  "portalList": "_portalList_1ij73_25",
  "right": "_right_1ij73_30"
};